import { useTranslation } from "react-i18next";
import { SelectField, TextField } from "@/shared/ui/core";
import { TextAreaField } from "@/features/admin/components";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { EditorialIconField } from "./EditorialIconField";
import { useBlockFilled } from "./useBlockFilled";
import { useCalloutTypeOptions } from "../../productOptions";

/**
 * Bloque 10 · La nota destacada.
 *
 * El TIPO no es solo color: es lo que la nota significa. Una advertencia
 * y una cita se leen distinto y la ficha las pinta distinto, así que
 * elegir mal el tipo cambia el mensaje. Por eso la lista está cerrada en
 * el contrato y no es texto libre.
 */
export function EditorialCalloutBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.callout`;
  const filled = useBlockFilled(name);
  const typeOptions = useCalloutTypeOptions();

  return (
    <EditorialBlock
      name={name}
      title={t("Nota destacada")}
      description={t("Un recuadro con algo que hay que leer sí o sí.")}
      filled={filled}
    >
      <TextField
        name={`${name}.title`}
        label={t("Título de la nota")}
        placeholder={t("Qué dice la ciencia")}
      />
      <SelectField
        name={`${name}.type`}
        label={t("Tipo")}
        options={typeOptions}
        placeholder={t("Sin tipo")}
      />
      <EditorialIconField name={`${name}.icon`} />
      <TextAreaField
        name={`${name}.body`}
        label={t("Texto")}
        rows={4}
        fieldClassName="sm:col-span-2"
      />
    </EditorialBlock>
  );
}
